// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { NormalTraffic, NormalTrafficT, verifyNormalTraffic } from "./normal-traffic";
import {
  TrafficVariant,
  unionToTrafficVariant,
  unionListToTrafficVariant,
} from "./traffic-variant";
import { ValuedTraffic, ValuedTrafficT, verifyValuedTraffic } from "./valued-traffic";

export class EscalatorTrafficMessage implements flatbuffers.IUnpackableObject<EscalatorTrafficMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): EscalatorTrafficMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsEscalatorTrafficMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: EscalatorTrafficMessage,
  ): EscalatorTrafficMessage {
    return (obj || new EscalatorTrafficMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsEscalatorTrafficMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: EscalatorTrafficMessage,
  ): EscalatorTrafficMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new EscalatorTrafficMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  trafficType(): TrafficVariant {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : TrafficVariant.NONE;
  }

  traffic<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  static startEscalatorTrafficMessage(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addTrafficType(builder: flatbuffers.Builder, trafficType: TrafficVariant) {
    builder.addFieldInt8(0, trafficType, TrafficVariant.NONE);
  }

  static addTraffic(builder: flatbuffers.Builder, trafficOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, trafficOffset, 0);
  }

  static endEscalatorTrafficMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // traffic
    return offset;
  }

  static createEscalatorTrafficMessage(
    builder: flatbuffers.Builder,
    trafficType: TrafficVariant,
    trafficOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    EscalatorTrafficMessage.startEscalatorTrafficMessage(builder);
    EscalatorTrafficMessage.addTrafficType(builder, trafficType);
    EscalatorTrafficMessage.addTraffic(builder, trafficOffset);
    return EscalatorTrafficMessage.endEscalatorTrafficMessage(builder);
  }

  unpack(): EscalatorTrafficMessageT {
    return new EscalatorTrafficMessageT(
      this.trafficType(),
      (() => {
        const temp = unionToTrafficVariant(this.trafficType(), this.traffic.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
    );
  }

  unpackTo(_o: EscalatorTrafficMessageT): void {
    _o.trafficType = this.trafficType();
    _o.traffic = (() => {
      const temp = unionToTrafficVariant(this.trafficType(), this.traffic.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
  }

  unpackFields(...fields: string[]): EscalatorTrafficMessageT {
    const t = new EscalatorTrafficMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("traffic_type")) {
      t.trafficType = this.trafficType();
    }
    if (fieldSet.has("traffic")) {
      t.traffic = (() => {
        const temp = unionToTrafficVariant(this.trafficType(), this.traffic.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    return t;
  }
}

export class EscalatorTrafficMessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public trafficType: TrafficVariant = TrafficVariant.NONE,
    public traffic: NormalTrafficT | ValuedTrafficT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.traffic === null || this.traffic === undefined) {
      throw new Error('Required field "traffic" is not set');
    }
    const traffic = builder.createObjectOffset(this.traffic);

    return EscalatorTrafficMessage.createEscalatorTrafficMessage(
      builder,
      this.trafficType,
      traffic,
    );
  }

  clone(): EscalatorTrafficMessageT {
    const obj = new EscalatorTrafficMessageT();
    obj.trafficType = this.trafficType;
    obj.traffic =
      this.traffic !== null && typeof (this.traffic as any).clone === "function"
        ? (this.traffic as any).clone()
        : this.traffic;
    return obj;
  }

  equals(other: EscalatorTrafficMessageT): boolean {
    if (this.trafficType !== other.trafficType) return false;
    if (this.traffic !== null && other.traffic !== null) {
      if (typeof (this.traffic as any).equals === "function") {
        if (!(this.traffic as any).equals(other.traffic)) return false;
      } else if (this.traffic !== other.traffic) return false;
    } else if (this.traffic !== other.traffic) return false;
    return true;
  }
}

export function verifyEscalatorTrafficMessage(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, "traffic");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // NormalTraffic
            {
              const o = verifier.readInt32(pos);
              verifyNormalTraffic(verifier, pos + o);
            }
            break;
          case 2: // ValuedTraffic
            {
              const o = verifier.readInt32(pos);
              verifyValuedTraffic(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, "traffic");
  } finally {
    verifier.popDepth();
  }
}
